// extracted by mini-css-extract-plugin
export var designArtifactsStyles = "design-artifacts-module--designArtifactsStyles--1qb+q";
export var panelStyles = "design-artifacts-module--panelStyles--wYl8r";
export var pagerStyles = "design-artifacts-module--pagerStyles--sW-b6";
export var randomObjectsStyles = "design-artifacts-module--randomObjectsStyles--cWOE8";
export var prototypesStyles = "design-artifacts-module--prototypesStyles--il6Ie";